/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface ComponentOverrideConfigsSpec { 
    vcds_service_type: VcdsServiceTypeEnum;
    overrides?: object;
    effective?: object;
}
export namespace ComponentOverrideConfigsSpec {
}


